// frontend/admin-portal/src/pages/Unauthorized.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Title } from "@fiberhome/shared-ui";

export default function Unauthorized() {
  const navigate = useNavigate();
  return (
    <div className="container text-center py-5">
      <Card>
        <Title level={1}>403</Title>
        <p className="text-muted">
          You don't have permission to access this page.
        </p>
        <Button variant="primary" onClick={() => navigate("/")}>
          Go to Dashboard
        </Button>
      </Card>
    </div>
  );
}
